module.exports = __webpack_public_path__ + "static/img/banner004.ebffdf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner004.jpg
// module id = 3YYt
// module chunks = 15